import { Link } from 'react-scroll';
import AudioControl from './AudioControl';

const Route = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 bg-white bg-opacity-90 shadow-sm z-50 backdrop-blur-md">
  <div className="max-w-screen-lg mx-auto px-4 py-3 flex flex-wrap justify-center space-x-4">
    {[{link: 'Hero', title: 'Save de date' }, { link: 'Couple', title: 'Nosotros' }, { link: 'Events', title: 'Evento' }, { link: 'Hotels', title: 'Alojamiento' }, { link: 'Transportation', title: 'Transporte' }, { link: 'Story', title: 'Nuestra historia'}, { link: 'RSVP', title: 'Confirmación' }, { link: 'Gift', title: 'Sobre digital' }].map((item) => (
      <Link
        key={item.link}
        to={item.link}
        smooth={true}
        duration={500}
        className="text-rose-600 hover:text-rose-700 cursor-pointer font-semibold text-sm md:text-base"
      >
        {item.title}
      </Link>
    ))}
    <AudioControl />
  </div>
</nav>

  );
};

export default Route;